module.exports = __webpack_public_path__ + "img/header-diamondJewelryBestseller.f843947.jpg";